export default __webpack_public_path__ + "static/media/banner-1-2.46209e26.png";